import React from 'react';
import {HStack, Text, VStack} from '@tempo/core';
import type {TdProps} from '@components/Table/core/Td';
import Td from '@components/Table/core/Td';
import type {SubLabel} from '@deezer/next/features/ClaimAccess/types';

type LabelNameCellProps = {
	label: SubLabel;
} & TdProps;

const LabelNameCell = ({label, ...rest}: LabelNameCellProps) => {
	const {name, upc} = label;

	return (
		<Td whiteSpace="pre-wrap" {...rest}>
			<HStack spacing="spacing.m">
				<VStack alignItems="initial" spacing={0}>
					<Text
						noOfLines={1}
						fontWeight="semibold"
						wordBreak="break-all"
						data-testid="artist-name-cell-title"
					>
						{name}
					</Text>
					<Text
						noOfLines={1}
						wordBreak="break-all"
						data-testid="artist-name-cell-upc"
						display={{base: 'block', sm: 'none'}}
					>
						{upc}
					</Text>
				</VStack>
			</HStack>
		</Td>
	);
};

export default LabelNameCell;
